
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSleetColour as ObiLightningSleetColourElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-sleet-colour.js';
 
 
 

 
 export const ObiLightningSleetColour = createComponent({
   react: React,
   tagName: 'obi-lightning-sleet-colour',
   elementClass: ObiLightningSleetColourElement,
   events: {
     
   }
  });
 
 